import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { SplashAccessGuard } from './public/splash-screen/splash-screen.page';
import { AntiAuthGuard } from './shared/guards/anti-auth/anti-auth.guard';
import { AuthGuard } from './shared/guards/auth/auth.guard';
import { CanActivateOverlayGuard } from './shared/guards/can-activate-overlay.guard';
import { RegisterGuard } from './shared/guards/profile/register.guard';
import { ReseteoGuard } from './shared/guards/reseteo/reseteo.guard';

const routes: Routes = [
  { path: '', redirectTo: 'splash-screen', pathMatch: 'full' },
  // ! Sin Guards
  {
    path: 'splash-screen',
    loadChildren: () => import('./public/splash-screen/splash-screen.module').then(m => m.SplashScreenPageModule),
    canLoad: [SplashAccessGuard],
    canActivate: [SplashAccessGuard]
  },
  {
    path: 'main',
    loadChildren: () => import('./private/main/main.module').then(m => m.MainPageModule),
    canActivate: [CanActivateOverlayGuard]
  },
  {
    path: 'home',
    loadChildren: () => import('./public/home/home.module').then(m => m.HomePageModule),
    canActivate: [CanActivateOverlayGuard, AntiAuthGuard],
    canLoad: [AntiAuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./public/auth/login/login.module').then(m => m.LoginPageModule),
    canActivate: [AntiAuthGuard],
    canLoad: [AntiAuthGuard]
  },
  {
    path: 'contenido-cliente',
    loadChildren: () => import('./public/contenido-cliente/contenido-cliente.module').then(m => m.ContenidoClientePageModule),
    canActivate: [CanActivateOverlayGuard, AntiAuthGuard],
    canLoad: [AntiAuthGuard]
  },
  {
    path: 'registro/:slide',
    loadChildren: () => import('./public/auth/registro/registro.module').then(m => m.RegistroPageModule),
    canActivate: [CanActivateOverlayGuard, AntiAuthGuard],
    canLoad: [AntiAuthGuard]
  },
  {
    path: 'perfil-registro',
    loadChildren: () => import('./public/auth/perfil-registro/perfil-registro.module').then(m => m.PerfilRegistroPageModule),
    canActivate: [CanActivateOverlayGuard, RegisterGuard, AntiAuthGuard],
    canLoad: [RegisterGuard, AntiAuthGuard]
  },
  {
    path: 'ReseteoUsuario',
    loadChildren: () => import('./public/reset-user/reset-user.module').then(m => m.ResetUserPageModule),
    canActivate: [ReseteoGuard, AntiAuthGuard],
    canLoad: [ReseteoGuard, AntiAuthGuard]
  },
  {
    path: 'legales/:document',
    loadChildren: () => import('./private/terminos/terminos.module').then(m => m.TerminosPageModule)
  },
  {
    path: 'eliminar-cuenta',
    loadChildren: () => import('./public/delete-account/delete-account.module').then(m => m.DeleteAccountPageModule),
    canActivate: [AntiAuthGuard],
    canLoad: [AntiAuthGuard]
  },
  // ! Con Guards
  {
    path: 'Mecanica',
    loadChildren: () => import('./private/mecanica/mecanica.module').then(m => m.MecanicaPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Contacto',
    loadChildren: () => import('./private/contacto/contacto.module').then(m => m.ContactoPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Califica',
    loadChildren: () => import('./private/califica/califica.module').then(m => m.CalificaPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Centro-Asistencia',
    loadChildren: () => import('./private/centro-asistencia/centro-asistencia.module').then(m => m.CentroAsistenciaPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Notificationes',
    loadChildren: () => import('./private/notificaciones/notificaciones.module').then(m => m.NotificacionesPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Historico',
    loadChildren: () => import('./private/historico/historico.module').then(m => m.HistoricoPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'perfil',
    loadChildren: () => import('./private/perfil/perfil.module').then(m => m.PerfilPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'ticket-preventa',
    loadChildren: () => import('./private/ticket-preventa/ticket-preventa.module').then(m => m.TicketPreventaPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'ticket-entrega',
    loadChildren: () => import('./private/ticket-entrega/ticket-entrega.module').then(m => m.TicketEntregaPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Autoevaluacion',
    loadChildren: () => import('./private/foto-exito/foto-exito.module').then(m => m.FotoExitoPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Camera-Preview/:task_id',
    loadChildren: () => import('./private/camera-preview/camera-preview.module').then(m => m.CameraPreviewPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Crece-Mas',
    loadChildren: () => import('./private/crece-mas/crece-mas.module').then(m => m.CreceMasPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Crece-Mas/:context',
    loadChildren: () => import('./private/crece-mas/crece-mas.module').then(m => m.CreceMasPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Juegos',
    loadChildren: () => import('./private/games/games.module').then(m => m.GamesPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Load-Game',
    loadChildren: () => import('./private/games/load-game/load-game.module').then(m => m.LoadGamePageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Leaderboard',
    loadChildren: () => import('./private/leaderboard/leaderboard.module').then(m => m.LeaderboardPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'CancelarCuenta',
    loadChildren: () => import('./private/cancelar-cuenta/cancelar-cuenta.module').then(m => m.CancelarCuentaPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'ResultadoEjecucion/:palanca',
    loadChildren: () => import('./private/result-ejecucion/result-ejecucion.module').then(m => m.ResultEjecucionPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Impulsa-GEPP',
    loadChildren: () => import('./private/impulsa-gepp/impulsa-gepp.module').then(m => m.ImpulsaGeppPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  // ! Url's Ecommerce V2
  {
    path: 'Tienda',
    loadChildren: () => import('./private/getm-ecommerce/getm-ecommerce.module').then(m => m.GetmEcommercePageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Carrito',
    loadChildren: () => import('./private/getm-cart/getm-cart.module').then(m => m.GetmCartPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  // Thank you page V2
  {
    path: 'Confirmacion',
    loadChildren: () => import('./private/getm-thank-you-page/getm-thank-you.module').then(m => m.GetmThankYouPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  // ! Url's Ecommerce
  {
    path: 'TiendaGETM',
    loadChildren: () => import('./private/pedidos/pedidos.module').then(m => m.PedidosPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'MisPedidos',
    loadChildren: () => import('./private/historico-pedidos/historico-pedidos.module').then(m => m.HistoricoPedidosPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'CarritoGETM',
    loadChildren: () => import('./private/carrito/carrito.module').then(m => m.CarritoPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'ResumenPedido',
    loadChildren: () => import('./private/resumen-pedido/resumen-pedido.module').then(m => m.ResumenPedidoPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Orden',
    loadChildren: () => import('./private/order-placed-wa/order-placed-wa.module').then(m => m.OrderPlacedWaPageModule),
    canActivate: [AuthGuard, CanActivateOverlayGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'TokenExpirado',
    loadChildren: () => import('./private/expired-token-wa/expired-token-wa.module').then(m => m.ExpiredTokenWaPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'Recomendados',
    loadChildren: () => import('./private/recommended/recommended.module').then(m => m.RecommendedPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'PedidoInteligente',
    loadChildren: () => import('./private/suggested-order-list/suggested-order-list.module').then(m => m.SuggestedOrderListPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: 'Enfriadores',
    loadChildren: () => import('./private/enfriadores/enfriadores.module').then(m => m.EnfriadoresPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: 'Cambios-Producto',
    loadChildren: () => import('./private/cambios-mercado/cambios-mercado.module').then(m => m.CambiosMercadoPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard]
  },
  {
    path: 'product/:clave',
    loadChildren: () => import('./private/product-detail/product-detail.module').then(m => m.ProductDetailPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
  {
    path: 'promocion/:clave',
    loadChildren: () => import('./private/promo-detail/promo-detail.module').then(m => m.PromoDetailPageModule),
    canActivate: [AuthGuard],
    canLoad: [AuthGuard],
  },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
